<style lang="scss">
$industrie-blue: rgba(0, 90, 134, 1);

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

a:hover {
  text-decoration: none;
}
* {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

$klz-red: #c50c0e;
.btn-all {
  border: 0;
  background: none;
  background: #eee;
  padding: 10px 15px;
  margin-top: 10px;
  text-transform: uppercase;
  font-size: 80%;
  letter-spacing: 1px;
  @media (max-width: 768px) {
    width: 100%;
    display: block;
  }
  &:hover {
    background: $klz-red;
    color: #fff;
  }

  &.red {
    background: $klz-red;
    color: #fff;
  }
}
</style>

<template>
  <div id="app">
    <Nav />
    <router-view />
  </div>
</template>

<script type="ts">
import Vue from 'vue';
import Nav from '@/components/Nav.vue'
import textfit from 'textfit';


export default Vue.extend({
  name: 'App',
  components: {
    Nav,
  },
methods: {
  parseUrl: function(url) {
    const parser = document.createElement('a');
    parser.href = url;
    return parser;
  }
}
});
</script>
